module.exports = __webpack_public_path__ + "img/result_logo.d3f3fff5.png";